import {
  useLazyQuery as useApolloLazyQuery,
  useMutation as useApolloMutation,
  useQuery as useApolloQuery,
} from "@apollo/client";
import { notification } from "antd";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import {
  isAuthConnectionError,
  resolveApiErrorMessage,
} from "utils/helpers/graphql-errors";

const notifyQueryError = (error, apiErrors) => {
  if (isAuthConnectionError(error)) return;
  notification.error({ message: apiErrors.GENERIC });
};

const useMutation = (mutation, options = {}) => {
  const { apiErrorOptions, onError, ...apolloOptions } = options;
  const { t } = useTranslation(NAME_SPACES.ERRORS);
  const API_ERRORS = t("API", { returnObjects: true });
  return useApolloMutation(mutation, {
    ...apolloOptions,
    onError:
      onError ||
      ((e) => {
        if (isAuthConnectionError(e)) return;
        notification.error({
          message: resolveApiErrorMessage(e, API_ERRORS, apiErrorOptions),
        });
      }),
  });
};

const useQuery = (query, options = {}) => {
  const { t } = useTranslation(NAME_SPACES.ERRORS);
  const API_ERRORS = t("API", { returnObjects: true });
  return useApolloQuery(query, {
    onError: (error) => notifyQueryError(error, API_ERRORS),
    ...options,
  });
};

const useLazyQuery = (query, options = {}) => {
  const { t } = useTranslation(NAME_SPACES.ERRORS);
  const API_ERRORS = t("API", { returnObjects: true });
  return useApolloLazyQuery(query, {
    onError: (error) => notifyQueryError(error, API_ERRORS),
    ...options,
  });
};

export { useLazyQuery, useMutation, useQuery };
